import { EventEmitter, Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PopupConfig } from 'src/app/component/popup/popup.component';
import { SnackBarComponent } from './../component/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  event = new EventEmitter();

  constructor(private snackBar: MatSnackBar) {}

  popup(config: PopupConfig) {
    this.event.emit(config);
  }

  /**
   * HTTP 에러를 서버 메시지(err.error.message) 우선으로 팝업 노출한다.
   * NestJS ValidationPipe의 message 배열도 개행으로 합쳐 표시한다.
   * error-http-interceptor 가 서버 메시지를 이미 팝업한 NNB_ERROR_TYPE 응답(5xx, 400/404 — 정원 초과 101 만 예외)은
   * 건너뛴다. NNB 형식이 아닌 5xx 는 인터셉터가 영문 'Internal server error' 를 띄우므로 fallback 으로 덮어쓴다.
   * 403 은 인터셉터가 항상 안내하므로 서버 사유가 없을 때만 건너뛴다 — 사유가 있으면 그 문구를 보여준다.
   */
  popupError(
    err:
      | { status?: number; error?: { message?: string | string[]; type?: string; error?: { id?: number } } }
      | null
      | undefined,
    options: { title: string; fallback: string },
  ) {
    const status = err?.status ?? 0;
    const raw = err?.error?.message;
    const serverMessage = Array.isArray(raw) ? raw.join('\n') : raw;
    const shownByInterceptor =
      (status >= 500 && err?.error?.type === 'NNB_ERROR_TYPE') ||
      ((status === 400 || status === 404) && err?.error?.type === 'NNB_ERROR_TYPE' && err.error?.error?.id !== 101) ||
      (status === 403 && !serverMessage?.trim());
    if (shownByInterceptor) return;
    const isClientError = typeof err?.status === 'number' && err.status >= 400 && err.status < 500;
    this.popup({
      title: options.title,
      description: isClientError && serverMessage?.trim() ? serverMessage : options.fallback,
      cancelLabel: '확인',
    });
  }

  /**
   * HTTP 에러를 서버 메시지(err.error.message) 우선으로 토스트 노출한다.
   * 5xx는 서버가 'Internal server error' 같은 영문 기본 문구를 주므로 fallback을 쓴다.
   */
  toastError(
    err: { status?: number; error?: { message?: string | string[] } } | null | undefined,
    fallback: string,
    verticalPosition?: 'top' | 'bottom',
  ) {
    const raw = err?.error?.message;
    const message = Array.isArray(raw) ? raw.join('\n') : raw;
    const isClientError = typeof err?.status === 'number' && err.status >= 400 && err.status < 500;
    this.toast(isClientError && message?.trim() ? message : fallback, verticalPosition);
  }

  toast(message: string, verticalPosition?: 'top' | 'bottom', type?: string, icon?: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: { message, type, icon },
      duration: 3500,
      horizontalPosition: 'center',
      verticalPosition: verticalPosition ?? 'bottom',
      panelClass: 'nnb-snack-bar',
    });
  }
}
